export default {"src":"/_next/static/media/review-source-airbnb.c85caccb.svg","height":22,"width":68};